import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { loadRuntimeConfig } from './config/runtimeConfig.js';
import { createUserManager, handleSigninCallback } from './auth/oidc.js';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No root element');
const root = ReactDOM.createRoot(rootEl);

function ConfigError({ message }: { message: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f7f5]">
      <div className="text-center max-w-md px-6">
        <h1 className="text-sm font-semibold text-[#37352f] mb-1">
          Migration Tools is not configured
        </h1>
        <p className="text-sm text-[#73726e]">{message}</p>
        <p className="text-xs text-[#aeaaa4] mt-2">
          Deploy a config.json next to index.html (see public/config.example.json).
        </p>
      </div>
    </div>
  );
}

async function start() {
  let config;
  try {
    config = await loadRuntimeConfig();
  } catch (err) {
    root.render(<ConfigError message={err instanceof Error ? err.message : String(err)} />);
    return;
  }

  const userManager = createUserManager(config);
  // Finish a sign-in redirect before the router reads the URL.
  const authError = await handleSigninCallback();

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App userManager={userManager} initialAuthError={authError} />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void start();
